import BaseModel from './base.model';
import { Url } from 'url';

class PaySimpleCheckoutTokenModel extends BaseModel {
  public JwtToken: string;
  public Expiration: string;
  public url: string;
}

export default PaySimpleCheckoutTokenModel;
